import { useState } from 'react'
import { errorText } from '../api.ts'
import { SearchBox } from '../components/SearchBox.tsx'
import { useCompany } from '../company.ts'
import { Loading, Notice, when } from '../ui.tsx'

/** The company's sign-ins, newest first: who signed in, when, and to what. ICE keeps the
 *  whole access log; this shows the last 200 sign-ins. */
export function Logs({ companyId }: { companyId: string }) {
  const detail = useCompany(companyId)
  const [query, setQuery] = useState('')
  if (detail.isPending) return <Loading />
  if (detail.isError) return <Notice>{errorText(detail.error)}</Notice>
  const { signIns, appCatalog } = detail.data
  const appName = new Map(appCatalog.map((a) => [a.appId, a.name]))
  const q = query.trim().toLowerCase()
  const shown = q
    ? signIns.filter((e) => (e.personName ?? '').toLowerCase().includes(q) || (e.personEmail ?? '').toLowerCase().includes(q))
    : signIns

  return (
    <section>
      <div className="section-head">
        <div>
          <h1>Logs</h1>
          <p className="muted">Your users' sign-ins, newest first. The last 200 are shown.</p>
        </div>
        {signIns.length > 0 && <SearchBox value={query} onChange={setQuery} placeholder="Search users" width={260} />}
      </div>
      {signIns.length === 0 ? (
        <p className="muted">Nobody has signed in yet.</p>
      ) : shown.length === 0 ? (
        <p className="muted">Nobody matches “{query.trim()}”.</p>
      ) : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr><th>When</th><th>User</th><th>Signed in to</th></tr>
            </thead>
            <tbody>
              {shown.map((e) => (
                <tr key={e.id}>
                  <td className="nowrap">{when(e.at)}</td>
                  <td>
                    <div className="person">
                      <strong>{e.personName ?? 'Someone since deleted'}</strong>
                      {e.personEmail && <span className="muted small">{e.personEmail}</span>}
                    </div>
                  </td>
                  <td>{e.appId ? appName.get(e.appId) ?? e.appId : e.surface === 'dashboard' ? 'Dashboard' : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}
